import { Routes } from '@angular/router';

import { authGuard } from './guards/auth.guard';

export const routes: Routes = [
  {
    path: 'home',
    loadComponent: () =>
      import('./components/home/home.component').then(
        (mod) => mod.HomeComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'darequests',
    loadComponent: () =>
      import('./components/darequest/list/dar.component').then(
        (mod) => mod.DARComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'darequests/file/:id',
    loadComponent: () =>
      import('./components/darequest/fileupload/dafile.component').then(
        (mod) => mod.DAFileComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'dojweb',
    loadComponent: () =>
      import('./components/doj/list/doj.component').then(
        (mod) => mod.DojComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'dragerdocuments',
    loadComponent: () =>
      import('./components/draeger/draeger.component').then(
        (mod) => mod.DraegerComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'efile',
    loadComponent: () =>
      import('./components/efile/efile.component').then(
        (mod) => mod.EfileComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'newcase/narrative/:id',
    loadComponent: () =>
      import('./components/newcase/addnarrative/narrative.component').then(
        (mod) => mod.EfileNarrativeComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'newcase/warrant/:id',
    loadComponent: () =>
      import('./components/newcase/addwarrant/warrant.component').then(
        (mod) => mod.AddWarrantComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'newcase',
    loadComponent: () =>
      import('./components/newcase/newcase.component').then(
        (mod) => mod.NewCaseComponent
      ),
    canActivate: [authGuard],
  },

  {
    path: 'courtprintstatus',
    loadComponent: () =>
      import('./components/eprint/eprint.component').then(
        (mod) => mod.EprintComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'propertyrelease',
    loadComponent: () =>
      import('./components/property/property.component').then(
        (mod) => mod.PropertyComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'reports',
    loadComponent: () =>
      import('./components/report/report.component').then(
        (mod) => mod.ReportComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'employeemanagement',
    loadComponent: () =>
      import('./components/users/list/users.component').then(
        (mod) => mod.UsersEmpComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'search/:id',
    loadComponent: () =>
      import('./components/search/list.component').then(
        (mod) => mod.SearchComponent
      ),
    canActivate: [authGuard],
  },

  {
    path: 'login',
    loadComponent: () =>
      import('./components/login/signin/siginin.component').then(
        (mod) => mod.SigninComponent
      ),
  },
  {
    path: 'token',
    loadComponent: () =>
      import('./components/login/token/token.component').then(
        (mod) => mod.TokenComponent
      ),
  },

  {
  path: 'maintenance',
  loadComponent: () =>
    import('./maintenance/maintenance.component').then(
      (mod) => mod.MaintenanceComponent
    ),
  },
  

  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full',
  },
];
